
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _, { isNull } from 'lodash';
import { connect } from 'react-redux';
// import UserProfileMain from './index';
import { Article, CreateRecipe, RecipeDetails, VideoArticle, Waiting } from '../../components';
import { Switch, Route } from 'react-router-dom';
import WellnessHub from './WellnessHub';
import CategoryDetailsPage from './CategoryDetailsPage';
import WatchedHistory from './WatchedHistory';
import SavedData from './SavedData';
import SearchResultsPage from './SearchResultsPage';
import { likeUnlikeEducationPost, updateUserGlobalPoints } from '../../redux/actions';
import { getPermissionStatus } from '../../utils/methods';
import EditRecipeForm from './EditRecipeForm';
import EditArticleForm from '../../components/Form/EditArticleForm';
import CreateArticleForm from '../../components/Form/createArticleForm';
import CreateArticleQuiz from '../../components/Article/CreateArticleQuiz';
import EditArticleQuiz from '../../components/Article/EditArticleQuiz';
// import HealthReport from '../../components/UserProfile/healthReportCard'

class WellnessResources extends Component {
  constructor(props) {
    super(props);
  }

  renderWellnessDashboard = () => {
    const { companyId, history,userPermissions, role} = this.props;
    const createRecipe = (getPermissionStatus("Create recipe", userPermissions));
    const createArticle = (getPermissionStatus("Create article", userPermissions));
    return(<WellnessHub companyId={companyId} history={history}  createRecipePermission={createRecipe} createArticlePermission={createArticle} role={role}/>)
  }

  renderDetailsPage = () => {
    const { companyId, history} = this.props;
    return(<CategoryDetailsPage companyId={companyId} history={history}/>)
  }

  renderWatchedHistoryPage = () => {
    const { companyId, history} = this.props;
    return(<WatchedHistory companyId={companyId} history={history}/>)
  }

  renderSavedDataPage = () => {
    const { companyId, history} = this.props;
    return(<SavedData companyId={companyId} history={history}/>)
  }

  renderSearchedResultsPage = () => {
    const { companyId, history} = this.props;
    return(<SearchResultsPage companyId={companyId} history={history}/>)
  }

  renderArticleDetailsPage = () => {
    const {role, updateUserGlobalPoints, userPermissions} = this.props;
    const updateArticle = (getPermissionStatus("Update article", userPermissions));
    const createOrUpdateQuiz = (getPermissionStatus("Create quiz", userPermissions) || getPermissionStatus("Update quiz", userPermissions) || getPermissionStatus("Delete quiz", userPermissions));
    return(<div style={{width:'1246px', margin:'20px auto'}}><Article             
      updateUserGlobalPoints={updateUserGlobalPoints}
      role={role}
      updateArticle={updateArticle}
      createOrUpdateQuiz={createOrUpdateQuiz}
      onClickFavoriteRibbon={this.onClickFavoriteRibbon}/></div>)
  }

  renderRecipeDetailsPage = () => {
    const {role, updateUserGlobalPoints, userPermissions,location,history} = this.props;
    const updateRecipe = (getPermissionStatus("Update recipe", userPermissions));
    return(<div style={{width:'1246px', margin:'20px auto'}}><RecipeDetails
      history={history}
      location={location}
      updateUserGlobalPoints={updateUserGlobalPoints}
      categoryTitle="recipes Categories"
      role={role}
      updateRecipe={updateRecipe}
      onClickFavoriteRibbon={this.onClickFavoriteRibbon}
    /></div>)
  }

  renderFitnessDetailsPage = () => {
    const {updateUserGlobalPoints, userPermissions,location,history,role} = this.props;
    const editVideo = (getPermissionStatus("Edit video", userPermissions));
    return(<div style={{width:'1246px', margin:'20px auto'}}><VideoArticle
      history={history}
      updateUserGlobalPoints={updateUserGlobalPoints}
      // featuredVideos={featuredVideos}
      link="videos-library"
      allowedRoles={editVideo}
      onClickFavoriteRibbon={this.onClickFavoriteRibbon}
      location={location}
      marginTop="1"
      role={role}
    /></div>)
  }


  renderCreateRecipeform = () => {
    const {history,themesHeaderAll,userPermissions,themes} = this.props;
    
    const createRecipe = (getPermissionStatus("Create recipe", userPermissions));
    return(<div style={{width:'1246px', margin:'20px auto'}}>
      <CreateRecipe
        themesHeaderAll={themesHeaderAll}
        history={history}
        themes={themes}
        allowedRoles={createRecipe}
      /></div>)
  }



  renderEditRecipeform = () => {
    const {history,themesHeaderAll,userPermissions,themes} = this.props;
    
    const createRecipe = (getPermissionStatus("Create recipe", userPermissions));
    return(<div style={{width:'1246px', margin:'20px auto'}}>
      <EditRecipeForm
        themesHeaderAll={themesHeaderAll}
        history={history}
        themes={themes}
        allowedRoles={createRecipe}
      /></div>)
  }


  renderEditArticleform = () => {
    const {history,themesHeaderAll,userPermissions,themes,selectedAdventureCategories} = this.props;
    const updateArticle = (getPermissionStatus("Update article", userPermissions));
    return(<div style={{width:'1246px', margin:'20px auto'}}>
      <EditArticleForm
        themesHeaderAll={themesHeaderAll}
        history={history}
        themes={themes}
        allowedRoles={updateArticle}
        journey_category_id={selectedAdventureCategories}
      /></div>)
  }

  renderCreateArticleform = () => {
    const {history} = this.props;
    return(<div style={{width:'1246px', margin:'20px auto'}}>
      <CreateArticleForm
        history={history}
      /></div>)
  }

  onClickFavoriteRibbon = (type, typeId, likeStatus, favoriteStatus, featureType = 1) => {
    const { likeUnlikeEducationPost } = this.props;
    let obj =
    {
      "type": type,
      "type_id": typeId,
      "like_status": likeStatus,
    }
    if (featureType === 0) {
      obj['favorite_status'] = favoriteStatus;
    }
    likeUnlikeEducationPost(obj);
  }

  renderCreateArticleQuizform = () => {
    const {history} = this.props;
    return(<div style={{width:'1246px', margin:'20px auto'}}>
      <CreateArticleQuiz
        history={history}
      /></div>)
  }

  renderEditArticleQuizform = () => {
    const {history} = this.props;
    return(<div style={{width:'1246px', margin:'20px auto'}}>
      <EditArticleQuiz
        history={history}
      /></div>)
  }

  render() {
    const { user, userId} = this.props;
    if (_.isUndefined(user) || _.isNull(user) || _,isNull(userId) ) {
      return <Waiting />
    }
    return (
      <Switch>
        <Route path="/wellness-resources" render={this.renderWellnessDashboard} exact={true}/>
        <Route path="/wellness-resources/create-article" render={this.renderCreateArticleform} exact={true} />
        <Route path="/wellness-resources/create-recipe" render={this.renderCreateRecipeform} exact={true} />
        <Route path="/wellness-resources/edit-recipe/:id" render={this.renderEditRecipeform} exact={true} />
        <Route path="/wellness-resources/edit-article/:id" render={this.renderEditArticleform} exact={true} />
        <Route path="/wellness-resources/search" render={this.renderSearchedResultsPage} exact={true}/>
        <Route path="/wellness-resources/watched-history" render={this.renderWatchedHistoryPage} exact={true}/>
        <Route path="/wellness-resources/saved-data" render={this.renderSavedDataPage} exact={true}/>
        <Route path="/wellness-resources/:catgoryName" render={this.renderDetailsPage} exact={true}/>
        <Route path="/wellness-resources/article-details/:id" render={this.renderArticleDetailsPage}/>
        <Route path="/wellness-resources/article/add-quiz/:id" render={this.renderCreateArticleQuizform}/>
        <Route path="/wellness-resources/article/edit-quiz/:id" render={this.renderEditArticleQuizform}/>
        <Route path="/wellness-resources/recipe-details/:id" render={this.renderRecipeDetailsPage}/>
        <Route path="/wellness-resources/fitness-details/:id" render={this.renderFitnessDetailsPage}/>
      </Switch>
    );
  }
}
    
WellnessResources.propTypes = {
  user: PropTypes.object,
  userId: PropTypes.number,
  companyId: PropTypes.number,
  history: PropTypes.object.isRequired,
  userPermissions:PropTypes.array,
  likeUnlikeEducationPost: PropTypes.func,
  role: PropTypes.string.isRequired,
  updateUserGlobalPoints: PropTypes.func.isRequired,
  location:PropTypes.string,
  themesHeaderAll:PropTypes.array,
  themes: PropTypes.array,
  selectedAdventureCategories: PropTypes.array,
};

const mapStateToProps = (state) => ({
  user: state.profileData.user,
  themes: state.education.themes,
  userId: state.profileData.userId,
  themesHeaderAll:state.profileData.themesHeaderAll,
  userPermissions: state.profileData.userPermissions,
  selectedAdventureCategories: state.education.selectedAdventureCategories,
})

const mapDispatchToProps = (dispatch) => ({
  updateUserGlobalPoints: (actionId, activityType, callBackForUpdaingApiDetails) => dispatch(updateUserGlobalPoints(actionId, activityType, callBackForUpdaingApiDetails)),
  likeUnlikeEducationPost: (obj) => dispatch(likeUnlikeEducationPost(obj)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(((WellnessResources)));